import _color from '@/assets/utils/color.js';
<template>
  <div class="mx-auto w-3/4">
    <vx-card>
      <div class="vx-row mb-2 ml-1">
        <div style="width: 350px">
          <!-- Append Button -->
          <vx-input-group>
            <vs-input
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              label-placeholder="SKU Number"
              v-model="skus_code"
              :readonly="true"
            />

            <template slot="append">
              <div v-if="selShow" class="append-text btn-addon mt-4">
                <vs-button
                  color="success"
                  type="filled"
                  icon="search"
                  @click="searchInb"
                  >Search</vs-button
                >
              </div>
            </template>
          </vx-input-group>
          <!-- /Append Button -->
        </div>
      </div>

      <div class="vx-row mb-2">
        <div class="vx-col w-2/5">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="CMAN Number"
            v-model="refnum"
            :readonly="true"
          />
        </div>

        <div class="vx-col w-1/5">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="ItemNumber"
            v-model="itemnum"
            :readonly="true"
          />
        </div>
      </div>

      <div class="vx-row mb-2">
        <div class="vx-col w-2/5">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="HBL"
            @blur="$v.hbl.$touch()"
            :readonly="readonly"
            v-model="hbl"
          />
          <p v-if="$v.hbl.$error & $v.hbl.$dirty">
            Please Enter Required Data with Correct Format
          </p>
        </div>
      </div>

      <div class="vx-row mb-2">
        <div class="vx-col w-3/5">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-globe"
            icon-no-border
            label-placeholder="ShipperName"
            @blur="$v.shname.$touch()"
            v-model="shname"
          />
          <p v-if="$v.shname.$error & $v.shname.$dirty">
            Please Enter Required Data with Correct Format
          </p>
        </div>

        <div class="vx-col w-1/5">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="ShipperTAX"
            v-model="shtax"
          />
        </div>

        <div class="vx-col w-1/5">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-globe"
            icon-no-border
            label-placeholder="ShipperBranch"
            v-model="shbranch"
          />
        </div>
      </div>

      <div class="vx-row mb-2">
        <div class="vx-col w-2/5">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="ShipperNameAndAddress"
            @blur="$v.shnamea.$touch()"
            v-model="shnamea"
          />
        </div>
        <p v-if="$v.shnamea.$error & $v.shnamea.$dirty">
          Please Enter Required Data with Correct Format
        </p>

        <div class="vx-col w-2/5">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="ShipperStreet"
            v-model="shstreet"
          />
        </div>
      </div>

      <div class="vx-row mb-2">
        <div class="vx-col w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="ShipperDistrict"
            v-model="shdist"
          />
        </div>

        <div class="vx-col w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="ShipperSubProvince"
            v-model="shsubp"
          />
        </div>

        <div class="vx-col w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="ShipperProvince"
            v-model="shprov"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-dollar-sign"
            icon-no-border
            label-placeholder="PostCode"
            @blur="$v.shpostc.$touch()"
            v-model="shpostc"
          />
          <p v-if="$v.shpostc.$error & $v.shpostc.$dirty">
            Please Enter Required Data with Correct Format
          </p>
        </div>

        <div class="vx-col w-1/3 mt-5">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-dark">
                <span>ShipperCountry</span>
              </div>
            </template>
            <vs-select autocomplete v-model="shcountry" class="w-full">
              <vs-select-item
                v-for="country in countrys"
                :key="country.code"
                :value="country.code"
                :text="country.code"
              />
            </vs-select>
          </vx-input-group>
        </div>
      </div>

      <div class="vx-row -mt-4">
        <div class="vx-col w-1/5 -mt-2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
            label-placeholder="Code"
            v-model="por"
            :readonly="true"
          />
        </div>
        <div style="width: 500px" class="vx-col -mt-2">
          <vx-input-group>
            <vs-input
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              label-placeholder="PortOfReceipt"
              v-model="porname"
              :readonly="true"
            />

            <template slot="append">
              <div class="append-text btn-addon mt-5">
                <vs-button
                  color="success"
                  type="filled"
                  icon="search"
                  @click="searchPol"
                  >Search</vs-button
                >
              </div>
            </template>
          </vx-input-group>
        </div>
      </div>

      <div class="vx-row mt-2">
        <div class="vx-col w-3/5">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-globe"
            icon-no-border
            label-placeholder="ConsigneeName"
            @blur="$v.cnname.$touch()"
            v-model="cnname"
          />
          <p v-if="$v.cnname.$error & $v.cnname.$dirty">
            Please Enter Required Data with Correct Format
          </p>
        </div>

        <div class="vx-col w-1/5">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="ConsigneeTAX"
            v-model="cntax"
          />
        </div>
        <div class="vx-col w-1/5">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-globe"
            icon-no-border
            label-placeholder="ConsigneeBranch"
            v-model="cnbranch"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-2/5 pr-6 mt-3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="ConsigneeNameAndAddress"
            @blur="$v.cnnamea.$touch()"
            v-model="cnnamea"
          />
        </div>
        <p v-if="$v.cnnamea.$error & $v.cnnamea.$dirty">
          Please Enter Required Data with Correct Format
        </p>

        <div class="vx-col w-2/5 mt-3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="ConsigneeStreet"
            v-model="cnstreet"
          />
        </div>
      </div>

      <div class="vx-row mb-2 mt-2">
        <div class="vx-col w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="ConsigneeDistrict"
            v-model="cndist"
          />
        </div>

        <div class="vx-col w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="ConsigneeSubProvince"
            v-model="cnsubp"
          />
        </div>

        <div class="vx-col w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="ConsigneeProvince"
            v-model="cnprov"
          />
        </div>
      </div>

      <div class="vx-row mb-2">
        <div class="vx-col w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-dollar-sign"
            icon-no-border
            label-placeholder="PostCode"
            @blur="$v.cnpostc.$touch()"
            v-model="cnpostc"
          />
          <p v-if="$v.cnpostc.$error & $v.cnpostc.$dirty">
            Please Enter Required Data with Correct Format
          </p>
        </div>

        <div class="vx-col w-1/3 mt-5">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-dark">
                <span>ConsigneeCountry</span>
              </div>
            </template>
            <vs-select autocomplete v-model="cncountry" class="w-full">
              <vs-select-item
                v-for="country in countrys"
                :key="country.code"
                :value="country.code"
                :text="country.code"
              />
            </vs-select>
          </vx-input-group>
        </div>
      </div>

      <div class="vx-row -mt-4">
        <div class="vx-col w-3/5">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-globe"
            icon-no-border
            label-placeholder="Notify Name"
            v-model="notiname"
          />
        </div>

        <div class="vx-col w-1/5">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Notify Tax"
            v-model="notitax"
          />
        </div>
        <div class="vx-col w-1/5">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-globe"
            icon-no-border
            label-placeholder="Notify Branch"
            v-model="notibranch"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-2/5 pr-6 mt-3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="NotifyNameAndAddress"
            v-model="notinamea"
          />
        </div>

        <div class="vx-col w-2/5 mt-3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="NotifyStreet"
            v-model="notistreet"
          />
        </div>
      </div>

      <div class="vx-row mb-2 mt-2">
        <div class="vx-col w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="NotifyDistrict"
            v-model="notidist"
          />
        </div>

        <div class="vx-col w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="NotifySubProvince"
            v-model="notisubp"
          />
        </div>

        <div class="vx-col w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="NotifyProvince"
            v-model="notiprov"
          />
        </div>
      </div>

      <div class="vx-row mb-2">
        <div class="vx-col w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-dollar-sign"
            icon-no-border
            label-placeholder="PostCode"
            v-model="notipostc"
          />
        </div>

        <div class="vx-col w-1/3 mt-5">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-dark">
                <span>NotifyCountry</span>
              </div>
            </template>
            <vs-select autocomplete v-model="noticountry" class="w-full">
              <vs-select-item
                v-for="country in countrys"
                :key="country.code"
                :value="country.code"
                :text="country.code"
              />
            </vs-select>
          </vx-input-group>
        </div>
      </div>

      <div class="vx-row -mt-4">
        <div class="vx-col w-3/5">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-globe"
            icon-no-border
            label-placeholder="Tranship Name"
            v-model="transhipappe"
          />
        </div>
      </div>

      <div class="vx-row mt-2">
        <div class="vx-col w-3/5">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="ชื่อ ผู้ขนถ่ายสินค้า"
            v-model="transhipappt"
          />
        </div>

        <div class="vx-col w-1/5">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Tranship Tax"
            v-model="transhiptax"
          />
        </div>
        <div class="vx-col w-1/5">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-globe"
            icon-no-border
            label-placeholder="Tranship Branch"
            v-model="transhipappb"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-2/5 pr-6 mt-3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Tranship NameAndAddress"
            v-model="transhipnamea"
          />
        </div>

        <div class="vx-col w-2/5 mt-3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Tranship Street"
            v-model="transhipstreeta"
          />
        </div>
      </div>

      <div class="vx-row mb-2 mt-2">
        <div class="vx-col w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Tranship District"
            v-model="transhipdist"
          />
        </div>

        <div class="vx-col w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Tranship SubProvince"
            v-model="transhipsubp"
          />
        </div>

        <div class="vx-col w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Tranship Province"
            v-model="transhipprov"
          />
        </div>
      </div>

      <div class="vx-row mb-2">
        <div class="vx-col w-1/3">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-dollar-sign"
            icon-no-border
            label-placeholder="PostCode"
            v-model="transhippostc"
          />
        </div>

        <div class="vx-col w-1/3 mt-5">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-dark">
                <span>Tranship Country</span>
              </div>
            </template>
            <vs-select autocomplete v-model="transhipcountry" class="w-full">
              <vs-select-item
                v-for="country in countrys"
                :key="country.code"
                :value="country.code"
                :text="country.code"
              />
            </vs-select>
          </vx-input-group>
        </div>
      </div>

      <div class="vx-row -mt-4">
        <div class="vx-col w-1/3 -mt-4">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="TotalPackageAmount"
            @blur="$v.totalpckamount.$touch()"
            v-model="totalpckamount"
          />
          <p v-if="$v.totalpckamount.$error & $v.totalpckamount.$dirty">
            Please Enter Required Data with Correct Format
          </p>
        </div>

        <div class="vx-col w-1/3 mt-1">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-dark">
                <span>TotalPackageUnit</span>
              </div>
            </template>
            <vs-select
              autocomplete
              v-model="totalpckunit"
              class="w-full"
              :disabled="disabled"
            >
              <vs-select-item
                v-for="packag in packages"
                :key="packag.code"
                :value="packag.code"
                :text="packag.name"
              />
            </vs-select>
          </vx-input-group>
        </div>
      </div>

      <div class="vx-row -mt-2">
        <div class="vx-col w-1/3 -mt-4">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="TotalNetWeight"
      
            @blur="$v.totalnw.$touch()"
            v-model="totalnw"
          />
          <p v-if="$v.totalnw.$error & $v.totalnw.$dirty">
            Please Enter Required Data with Correct Format
          </p>
        </div>

        <div class="vx-col w-1/3 mt-1">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-dark">
                <span>TotalNetWeightUnit</span>
              </div>
            </template>
            <vs-select
              autocomplete
              v-model="totalnwunit"
              class="w-full"
              :disabled="disabled"
            >
              <vs-select-item
                v-for="packag in packages"
                :key="packag.code"
                :value="packag.code"
                :text="packag.name"
              />
            </vs-select>
          </vx-input-group>
        </div>
      </div>

      <div class="vx-row -mt-4">
        <div class="vx-col w-1/5 -mt-2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="TotalGrossWeight"
            
            @blur="$v.totalgw.$touch()"
            v-model="totalgw"
          />
          <p v-if="$v.totalgw.$error & $v.totalgw.$dirty">
            Please Enter Required Data with Correct Format
          </p>
        </div>

        <div class="vx-col w-2/5 mt-3">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-dark">
                <span>TotalGrossWeightUnit</span>
              </div>
            </template>
            <vs-select
              autocomplete
              v-model="totalgwunit"
              class="w-full"
              :disabled="disabled"
            >
              <vs-select-item
                v-for="packag in packages"
                :key="packag.code"
                :value="packag.code"
                :text="packag.name"
              />
            </vs-select>
          </vx-input-group>
        </div>
      </div>

      <div class="vx-row -mt-4">
        <div class="vx-col w-1/5 -mt-2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Quantity"
           
            @blur="$v.itemqty.$touch()"
            v-model="itemqty"
          />
          <p v-if="$v.itemqty.$error & $v.itemqty.$dirty">
            Please Enter Required Data with Correct Format
          </p>
        </div>

        <div class="vx-col w-2/5 mt-3">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-dark">
                <span>Quantity Unit</span>
              </div>
            </template>
            <vs-select
              autocomplete
              v-model="qtyunit"
              class="w-full"
              :disabled="disabled"
            >
              <vs-select-item
                v-for="packag in packages"
                :key="packag.code"
                :value="packag.code"
                :text="packag.name"
              />
            </vs-select>
          </vx-input-group>
        </div>
      </div>

      <div class="vx-row -mt-4">
        <div class="vx-col w-1/2 -mt-2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="ShippingMask"
            @blur="$v.shmarks.$touch()"
            v-model="shmarks"
          />
          <p v-if="$v.shmarks.$error & $v.shmarks.$dirty">
            Please Enter Required Data with Correct Format
          </p>
        </div>

        <div class="vx-col w-1/2 -mt-2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-link-2"
            icon-no-border
            label-placeholder="Description"
           
            @blur="$v.description.$touch()"
            v-model="description"
          />
          <p v-if="$v.description.$error & $v.description.$dirty">
            Please Enter Required Data with Correct Format
          </p>
        </div>
      </div>

      <div class="vx-row mt-8">
        <div class="vx-col w-2/5">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-dark">
                <span>Cargo Movement</span>
              </div>
            </template>
            <vs-select autocomplete v-model="cgmove" class="w-full">
              <vs-select-item
                v-for="cgmove in cgmoves"
                :key="cgmove.code"
                :value="cgmove.code"
                :text="cgmove.name"
              />
            </vs-select>
          </vx-input-group>
        </div>

        <div class="vx-col w-2/5">
          <vx-input-group class="mb-base">
            <template slot="prepend">
              <div class="prepend-text bg-dark">
                <span>Goods Cargo Type</span>
              </div>
            </template>
            <vs-select autocomplete v-model="goodcgtype" class="w-full">
              <vs-select-item
                v-for="cgtype in cgtypes"
                :key="cgtype.code"
                :value="cgtype.code"
                :text="cgtype.name"
              />
            </vs-select>
          </vx-input-group>
        </div>
      </div>

      <div class="vx-row -mt-4">
        <div class="vx-col w-3/5 -mt-2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-message-square"
            icon-no-border
            label-placeholder="Remark"
            v-model="remark"
          />
        </div>

        <div class="vx-col 1/5 -mt-2">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-eye"
            icon-no-border
            label-placeholder="Status"
            v-model="status"
            :readonly="true"
          />
        </div>
      </div>

      <div v-if="status != 'COMPLETE'" class="vx-row mt-6">
        <div class="vx-col w-full">
          <vs-button
            class="mr-3 mb-2"
            @click="onSubmit"
            :disabled="$v.$anyError"
            >Submit</vs-button
          >
          <vs-button color="warning" type="border" class="mb-2" @click="clsd"
            >Back</vs-button
          >
        </div>
      </div>
    </vx-card>

    <vs-popup fullscreen title="Inbdetails" :active.sync="popupActive4">
      <inbdetails
        v-if="popupActive4"
        :masrec="masrec"
        @recsel="gotfin4"
      ></inbdetails>
    </vs-popup>

    <vs-popup fullscreen title="Port" :active.sync="popupActive3">
      <ports v-if="popupActive3" @recsel="recsel3"></ports>
    </vs-popup>

    <!-- <b-modal :active.sync="popupActive3" :width="1024" scroll="keep">
      <ports v-if="popupActive3" @recsel="recsel3"></ports>
    </b-modal> -->

    <vx-card class="mt-2">
      <vs-tabs v-if="status != 'NEW'">
        <vs-tab
          label="Details Section Dangerous Goods"
          icon-pack="feather"
          icon="icon-home"
        >
          <dgs :cmansDetailsNumber="number" :cmanstatus="cmanstatus"></dgs>
        </vs-tab>
        <vs-tab
          label="Detail Section Container"
          icon-pack="feather"
          icon="icon-box"
        >
          <conts
            :cmansDetailsNumber="number"
            :cmanstatus="cmanstatus"
            :rfcar_code="rfcar_code"
          ></conts>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import { required, decimal, numeric } from "vuelidate/lib/validators";
import moment from "moment";
// import inbdetails from "../inbdetails/DataTable/AgGrid";
import inbdetails from "../inbdetails/grid.vue";
import ports from "../customsports/grid.vue";
import dgs from "../cmansdangerous/cmandang_main";
import conts from "../cmansconts/cmancont_main";

import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      userid: "",
      businessPartnersCode: "",
      companyGroupsCode: "",
      rfcar_code: "",
      notiname: "",
      notitax: "",
      notibranch: "",
      notinamea: "",
      notistreet: "",
      notidist: "",
      notisubp: "",
      notiprov: "",
      notipostc: "",
      noticountry: "",
      transhipappe: "",
      transhipappt: "",
      transhiptax: "",
      transhipappb: "",
      transhipnamea: "",
      transhipstreeta: "",
      transhipdist: "",
      transhipsubp: "",
      transhipprov: "",
      transhippostc: "",
      transhipcountry: "",
      disabled: false,
      readonly: false,
      cmanstatus: "",
      porname: "",
      number: "",
      processIndicatorsCode: "",
      masrec: "0",
      popupActive3: false,
      popupActive4: false,
      selShow: false,
      refnum: "",
      skus_code: "",
      itemnum: "",
      hbl: "",
      shname: "",
      shtax: "",
      shbranch: "",
      shnamea: "",
      shstreet: "",
      shdist: "",
      shsubp: "",
      shprov: "",
      shpostc: "",
      shcountry: "",
      por: "",
      cnname: "",
      cntax: "",
      cnbranch: "",
      cnnamea: "",
      cnstreet: "",
      cndist: "",
      cnsubp: "",
      cnprov: "",
      cnpostc: "",
      cncountry: "",
      totalpckamount: "",
      totalpckunit: "",
      totalnw: "",
      totalnwunit: "",
      totalgw: "",
      totalgwunit: "",
      itemqty: "",
      qtyunit: "",
      shmarks: "",
      description: "",
      cgmove: "",
      goodcgtype: "",
      remark: "",
      status: "NEW",
      packages: [],
      provinces: [],
      countrys: [],
      cgmoves: [],
      cgtypes: [],
    };
  },
  validations: {
    hbl: {
      required,
    },
    shname: {
      required,
    },
    shnamea: {
      required,
    },
    shpostc: {
      required,
      numeric,
    },
    shcountry: {
      required,
    },
    cnname: {
      required,
    },
    cnnamea: {
      required,
    },
    cnpostc: {
      required,
      numeric,
    },
    cncountry: {
      required,
    },
    totalpckamount: {
      required,
      decimal,
    },
    totalpckunit: {
      required,
    },
    totalnw: {
      required,
      decimal,
    },
    totalnwunit: {
      required,
    },
    totalgw: {
      required,
      decimal,
    },
    totalgwunit: {
      required,
    },
    itemqty: {
      required,
      decimal,
    },
    qtyunit: {
      required,
    },
    shmarks: {
      required,
    },
    description: {
      required,
    },
  },
  components: {
    inbdetails,
    ports,
    dgs,
    conts,
  },
  props: ["acstate", "recid", "cmansNumber"],
  methods: {
    async recsel3(val) {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
      this.popupActive3 = false;

      try {
        if (token) {
          const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

          this.popupActive2 = false;

          const response = await axios.get(
            `${BASE_API_URL}/inbound-svc/customsports/${val}`,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (!response.data) {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
          } else {
            this.por = response.data.code;
            this.porname = response.data.name;
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        this.$router.replace("/pages/login/");
      }
    },
    searchPol() {
      this.popupActive3 = true;
    },
    async gotfin4(val) {
      // console.log(val);
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        const response = await axios.get(
          `${BASE_API_URL}/inbound-svc/cmansdetails/${val}`,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        if (!response.data) {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Backend",
            text: response.data.message,
          });
        } else {
          this.hbl = response.data.hawb;
          this.skus_code = response.data.skus_code;
          this.totalpckamount = response.data.itempck;
          this.totalpckunit = response.data.packages_code;
          this.totalnw = response.data.itemnw;
          this.totalnwunit = response.data.nwunit;
          this.totalgw = response.data.itemnw;
          this.totalgwunit = response.data.gwunit;
          this.itemqty = response.data.itemqty;
          this.qtyunit = response.data.qtyunit;
          this.description = response.data.edescription;

          this.readonly = true;
          this.disabled = true;
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        this.$router.replace("/pages/login/");
      }

      this.popupActive4 = false;
    },
    searchInb() {
      // console.log("search");
      this.popupActive4 = true;
    },
    clsd: function () {
      let vm = this;

      vm.$emit("grid");
      // this.skus_code = this.hbl = this.shname = this.shnamea = this.shpostc = this.shcountry = this.shtax = this.shbranch = this.shstreet = this.shdist = this.shsubp = this.shprov = this.shpostc = this.shcountry = this.por = this.cnname = this.cntax = this.cnbranch = this.cnnamea = this.cnstreet = this.cndist = this.cnsubp = this.cnprov = this.cnpostc = this.cncountry = this.totalpckunit = this.totalnw = this.totalnwunit = this.qtyunit = this.shmarks = this.description = this.cgmove = this.goodcgtype = this.remark;
      // ("");
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    async onSubmit() {
      // alert("Hi");
      this.$v.$touch();
      let vm = this;

      if (this.$v.$invalid) {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
        });
        return;
      } else if (
        this.hbl == "" ||
        this.hbl == null ||
        this.shname == "" ||
        this.shname == null ||
        this.shnamea == "" ||
        this.shnamea == null ||
        this.shpostc == "" ||
        this.shpostc == null ||
        this.shcountry == "" ||
        this.shcountry == null ||
        this.cnname == "" ||
        this.cnname == null ||
        this.cnnamea == "" ||
        this.cnnamea == null ||
        this.cnpostc == "" ||
        this.cnpostc == null ||
        this.cncountry == "" ||
        this.cncountry == null ||
        this.totalpckamount == "" ||
        this.totalpckamount == null ||
        this.totalpckunit == "" ||
        this.totalpckunit == null ||
        // (this.totalnw == "") ||
        this.totalnwunit == "" ||
        this.totalnwunit == null ||
        this.totalgw == "" ||
        this.totalgw == null ||
        this.totalgwunit == "" ||
        this.totalgwunit == null ||
        // (this.itemqty == "") ||
        this.qtyunit == "" ||
        this.qtyunit == null ||
        this.shmarks == "" ||
        this.shmarks == null ||
        this.description == "" ||
        this.description == null
      ) {
        // console.log(this.hbl);
        // console.log(this.shname);
        // console.log(this.shnamea);
        // console.log(this.shpostc);
        // console.log(this.shcountry);
        // console.log(this.cnname);
        // console.log(this.cnnamea);
        // console.log(this.cnpostc);
        // console.log(this.cncountry);
        // console.log(this.totalpckunit);
        // console.log(this.totalpckamount);
        // console.log(this.totalnw);
        // console.log(this.totalnwunit);
        // console.log(this.totalgw);
        // console.log(this.totalgwunit);
        // console.log(this.itemqty);
        // console.log(this.qtyunit);
        // console.log(this.shmarks);
        // console.log(this.description);
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "Please Enter The Informaiton",
        });
        return;
      } else if (
        (this.cgmove == "3" || this.cgmove == "7" || this.cgmove == "L") &&
        (this.transhiptax == "" ||
          this.transhiptax == null ||
          this.transhipappb == "" ||
          this.transhipappb == null ||
          this.transhipappe == "" ||
          this.transhipappe == null ||
          this.transhipappt == "" ||
          this.transhipappt == null ||
          this.transhipstreeta == "" ||
          this.transhipstreeta == null ||
          this.transhippostc == "" ||
          this.transhippostc == null ||
          this.transhipcountry == "" ||
          this.transhipcountry == null)
      ) {
        // alert("Please Enter The Informaiton");
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "Transhipment ไม่สามารถว่างได้ หาก Cargo Movement คือ Transhipment (ขนของถ่ายลำ), Transit (ขนถ่ายของผ่านแดน), ผ่านแดนไปลาว",
        });
        return;
      }

      const formData = {
        companyGroupsCode: this.companyGroupsCode,
        number: this.number,
        processIndicatorsCode: this.processIndicatorsCode,
        skus_code: this.skus_code,
        refnum: this.refnum,
        cmansNumber: this.cmansNumber,
        itemnum: this.itemnum,
        hbl: this.hbl,
        shname: this.shname,
        shtax: this.shtax,
        shbranch: this.shbranch,
        shnamea: this.shnamea,
        shstreet: this.shstreet,
        shdist: this.shdist,
        shsubp: this.shsubp,
        shprov: this.shprov,
        shpostc: this.shpostc,
        shcountry: this.shcountry,
        por: this.por,
        cnname: this.cnname,
        cntax: this.cntax,
        cnbranch: this.cnbranch,
        cnnamea: this.cnnamea,
        cnstreet: this.cnstreet,
        cndist: this.cndist,
        cnsubp: this.cnsubp,
        cnprov: this.cnprov,
        cnpostc: this.cnpostc,
        cncountry: this.cncountry,
        totalpckamount: this.totalpckamount,
        totalpckunit: this.totalpckunit,
        totalnw: this.totalnw,
        totalnwunit: this.totalnwunit,
        totalgw: this.totalgw,
        totalgwunit: this.totalgwunit,
        itemqty: this.itemqty,
        qtyunit: this.qtyunit,
        shmarks: this.shmarks,
        description: this.description,
        cgmove: this.cgmove,
        goodcgtype: this.goodcgtype,
        remark: this.remark,
        acstate: this.acstate,
        recid: this.recid,
        notiname: this.notiname,
        notitax: this.notitax,
        notibranch: this.notibranch,
        notinamea: this.notinamea,
        notistreet: this.notistreet,
        notidist: this.notidist,
        notisubp: this.notisubp,
        notiprov: this.notiprov,
        notipostc: this.notipostc,
        noticountry: this.noticountry,
        transhipappe: this.transhipappe,
        transhipappt: this.transhipappt,
        transhiptax: this.transhiptax,
        transhipappb: this.transhipappb,
        transhipnamea: this.transhipnamea,
        transhipstreeta: this.transhipstreeta,
        transhipdist: this.transhipdist,
        transhipsubp: this.transhipsubp,
        transhipprov: this.transhipprov,
        transhippostc: this.transhippostc,
        transhipcountry: this.transhipcountry,
        editor: String(this.userid),
      };

      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
      // console.log(formData);

      if (token) {
        try {
          const response = await axios.post(
            `${BASE_API_URL}/inbound-svc/cmansdetails/create`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response.data.status != "success") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Success",
              text: response.data.message,
            });
            vm.$emit("grid");
          }
        } catch (error) {
          // return error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          // await this.$router.replace("/pages/login/");
        }
      }
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  async beforeCreate() {
    // console.log("beforecreate");
    const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

    try {
      if (token) {
        const formData = {
          searchval: "",
        };

        const response = await axios.post(
          `${BASE_API_URL}/inbound-svc/goodscargotypes/getGoodsCargoTypes`,
          formData,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        if (!response.data) {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Backend",
            text: response.data.message,
          });
        } else {
          this.cgtypes = response.data;
        }

        const response2 = await axios.post(
          `${BASE_API_URL}/inbound-svc/cargomovements/getCargoMovements`,
          formData,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        if (!response2.data) {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Backend",
            text: response2.data.message,
          });
        } else {
          this.cgmoves = response2.data;
        }

        const response3 = await axios.post(
          `${BASE_API_URL}/inbound-svc/countrys/getCountrys`,
          formData,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        if (!response3.data) {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Backend",
            text: response3.data.message,
          });
        } else {
          this.countrys = response3.data;
        }

        const response4 = await axios.post(
          `${BASE_API_URL}/inbound-svc/provinces/getProvinces`,
          formData,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        if (!response4.data) {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Backend",
            text: response4.data.message,
          });
        } else {
          this.provinces = response4.data;
        }

        const response5 = await axios.post(
          `${BASE_API_URL}/inbound-svc/packages/getPackages`,
          formData,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        if (!response5.data) {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Backend",
            text: response5.data.message,
          });
        } else {
          this.packages = response5.data;
        }

        const response6 = await axios.post(
          `${BASE_API_URL}/inbound-svc/protypes/getProtypes`,
          formData,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        if (!response6.data) {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Backend",
            text: response6.data.message,
          });
        } else {
          this.protypes = response6.data;
        }
      }
    } catch (error) {
      this.data = [];
      this.total = 0;
      this.loading = false;
      // throw error;
      alert("กรุณาเข้าระบบอีกครั้ง");
      // this.$router.replace("/pages/login/");
    }
  },
  mounted() {
    this.checkProfiles();
    // console.log(this.$acl.check('admin'));
  },
  async created() {
    // console.log(this.recid);
    // console.log(this.cmansNumber);
    const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

    try {
      const response = await axios.get(
        `${BASE_API_URL}/inbound-svc/cmans/${this.cmansNumber}`,
        {
          headers: { Authorization: "Bearer " + token.accessToken },
        }
      );

      if (!response.data) {
        this.loading = false;
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Error from Backend",
          text: response.data.message,
        });
      } else {
        this.refnum = response.data[0].refnum;
        this.processIndicatorsCode = response.data[0].processIndicatorsCode;
        this.rfcar_code = response.data[0].rfcar_code;

        if (response.data[0].processIndicatorsCode == "22") {
          this.selShow = true;
        }
      }
    } catch (error) {
      this.data = [];
      this.total = 0;
      this.loading = false;
      // throw error;
      alert("กรุณาเข้าระบบอีกครั้ง");
      // this.$router.replace("/pages/login/");
    }

    // console.log("create");

    if (this.recid != "0") {
      // alert("Edit");
      this.readonly = true;
      this.disabled = true;

      try {
        const response = await axios.get(
          `${BASE_API_URL}/inbound-svc/cmansdetails/${this.recid}`,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );
        // console.log(response.data)

        if (!response.data) {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Backend",
            text: response.data.message,
          });
        } else {
          // this.refnum = response.data.refnum;
          this.number = response.data.number;
          this.skus_code = response.data.skus_code;
          this.itemnum = response.data.itemnum;
          this.hbl = response.data.hbl;
          this.shname = response.data.shname;
          this.shtax = response.data.shtax;
          this.shbranch = response.data.shbranch;
          this.shnamea = response.data.shnamea;
          this.shstreet = response.data.shstreet;
          this.shdist = response.data.shdist;
          this.shsubp = response.data.shsubp;
          this.shprov = response.data.shprov;
          this.shpostc = response.data.shpostc;
          this.shcountry = response.data.shcountry;
          this.por = response.data.por;
          this.cnname = response.data.cnname;
          this.cntax = response.data.cntax;
          this.cnbranch = response.data.cnbranch;
          this.cnnamea = response.data.cnnamea;
          this.cnstreet = response.data.cnstreet;
          this.cndist = response.data.cndist;
          this.cnsubp = response.data.cnsubp;
          this.cnprov = response.data.cnprov;
          this.cnpostc = response.data.cnpostc;
          this.cncountry = response.data.cncountry;
          this.totalpckamount = response.data.totalpckamount;
          this.totalpckunit = response.data.totalpckunit;
          this.totalnw = response.data.totalnw;
          this.totalnwunit = response.data.totalnwunit;
          this.totalgw = response.data.totalgw;
          this.totalgwunit = response.data.totalgwunit;
          this.itemqty = response.data.itemqty;
          this.qtyunit = response.data.qtyunit;
          this.shmarks = response.data.shmarks;
          this.description = response.data.description;
          this.cgmove = response.data.cgmove;
          this.goodcgtype = response.data.goodcgtype;
          this.remark = response.data.remark;
          this.status = response.data.status;
          this.notiname = response.data.notiname;
          this.notitax = response.data.notitax;
          this.notibranch = response.data.notibranch;
          this.notinamea = response.data.notinamea;
          this.notistreet = response.data.notistreet;
          this.notidist = response.data.notidist;
          this.notisubp = response.data.notisubp;
          this.notiprov = response.data.notiprov;
          this.notipostc = response.data.notipostc;
          this.noticountry = response.data.noticountry;
          this.transhipappe = response.data.transhipappe;
          this.transhipappt = response.data.transhipappt;
          this.transhiptax = response.data.transhiptax;
          this.transhipappb = response.data.transhipappb;
          this.transhipnamea = response.data.transhipnamea;
          this.transhipstreeta = response.data.transhipstreeta;
          this.transhipdist = response.data.transhipdist;
          this.transhipsubp = response.data.transhipsubp;
          this.transhipprov = response.data.transhipprov;
          this.transhippostc = response.data.transhippostc;
          this.transhipcountry = response.data.transhipcountry;
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }

      // console.log(this.por)
      setTimeout(async () => {
        const response = await axios.get(
          `${BASE_API_URL}/inbound-svc/customsports/${this.por}`,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        if (!response.data) {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Backend",
            text: response.data.message,
          });
        } else {
          this.por = response.data.code;
          this.porname = response.data.name;
          this.cmanstatus = this.status;
        }
      }, 500);
    } else {
      let vm = this;
      vm.readonly = false;
      // vm.clsd();
    }
  },
};
</script>

<style scoped>
p {
  color: red;
}
</style>
